













import { Component, Emit, Vue } from 'vue-property-decorator'
import LoginStore from '@/modules/login/stores/LoginStore'

@Component({ inheritAttrs: false })
export default class RefreshCodeButton extends Vue {
  isPending = false

  refreshCode() {
    this.isPending = true
    this.submit()

    LoginStore.submitPhone().finally(() => {
      this.isPending = false
    })
  }

  @Emit()
  submit() {
    return true
  }
}
